import { DollarSign } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCurrency, currencyOptions, Currency } from "@/hooks/useCurrency";

const CurrencySelector = () => {
  const { currency, setCurrency } = useCurrency();

  const handleCurrencyChange = (newCurrency: Currency) => {
    setCurrency(newCurrency);
    window.location.reload();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-1 text-foreground hover:text-muted-foreground transition-smooth">
        <DollarSign className="w-4 h-4" />
        <span className="text-xs uppercase tracking-wider hidden sm:inline">
          {currency}
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 z-[70]">
        {currencyOptions.map((option) => (
          <DropdownMenuItem
            key={option.code}
            onClick={() => handleCurrencyChange(option.code as Currency)}
            className={currency === option.code ? "bg-muted" : ""}
          >
            <span className="mr-2">{option.symbol}</span>
            <span>{option.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default CurrencySelector;
